import DOMPurify from 'dompurify';
import VideoCard from 'components/molecules/videoCard';
import PropTypes from 'prop-types';
import { styleListMarkers } from './richText';

function decodeHtml(html) {
  if (!html) return '';

  const textarea = document.createElement('textarea');
  textarea.innerHTML = html;

  return textarea.value;
}

function toHtml(html) {
  const decodedHtml = decodeHtml(html || '');

  return {
    __html: styleListMarkers(DOMPurify.sanitize(decodedHtml)),
  };
}

export default function ContactHero({ data, overviewVideo }) {
  return (
    <>
      <section className='px-[24px] pt-[60px] text-center md:px-[56px] md:pt-[80px]'>
        <h1
          className='contact-page-rte text-[26px] font-bold leading-[30px] tracking-[0] text-black md:text-[48px] md:leading-[56px]'
          dangerouslySetInnerHTML={toHtml(data?.title || 'How can we help?')}
        />

        {data?.subtitle && (
          <p
            className='contact-page-rte mx-auto mt-[16px] max-w-[480px] text-[14px] font-normal leading-[21px] text-gray-600 md:text-[18px] md:leading-[28px]'
            dangerouslySetInnerHTML={toHtml(data.subtitle)}
          />
        )}
      </section>

      {overviewVideo?.enabled && (
      <section className='mt-[40px] md:mt-[60px]'>
        <VideoCard
          className='group relative flex h-[208px] flex-col items-center justify-center overflow-hidden rounded-[20px] md:h-[574px]'
          element={{
            title: overviewVideo.title,
            thumbnailUrl: overviewVideo.image,
            videoUrl: overviewVideo.button?.url,
          }}
          imageClassName='absolute inset-0 h-full w-full object-cover transition-transform duration-500 ease-out group-hover:scale-105'
          isActive
          playOverlay={(
            <>
              <div className='absolute inset-0 bg-black/50 transition-opacity duration-300 group-hover:opacity-30' />

              <div className='absolute inset-0 z-2 flex items-center justify-center'>
                <div className='flex flex-col items-center gap-[16px] md:gap-[24px]'>
                  <h2 className='contact-page-rte w-full max-w-[330px] text-center text-[22px] font-bold leading-[26px] text-white md:max-w-none md:text-[38px] md:leading-[44px]' dangerouslySetInnerHTML={toHtml(overviewVideo.title)} />

                  <div className='inline-flex h-[43px] items-center justify-center gap-[12px] rounded-[36px] bg-[#39A9F7] px-[24px] py-[12px] text-white transition hover:bg-[#2c9be8] md:h-[46px]'>
                    <span className='text-[16px] font-bold leading-[19px] md:text-[18px] md:leading-[22px]'>
                      {overviewVideo.button?.text || 'Watch Now'}
                    </span>

                    {overviewVideo.button?.icon === 'play' && (
                    <span className='flex h-[11px] w-[14px] items-center justify-center'>
                      <svg
                        width='13'
                        height='16'
                        viewBox='0 0 13 16'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'
                      >
                        <path
                          d='M1 1L12 8L1 15V1Z'
                          stroke='white'
                          strokeWidth='2'
                          strokeLinecap='round'
                          strokeLinejoin='round'
                        />
                      </svg>
                    </span>
                    )}
                  </div>
                </div>
              </div>
            </>
  )}
        />
      </section>
      )}
    </>
  );
}

ContactHero.propTypes = {
  data: PropTypes.shape({
    key: PropTypes.string,
    enabled: PropTypes.bool,
    order: PropTypes.number,
    title: PropTypes.string,
    subtitle: PropTypes.string,
  }),
  overviewVideo: PropTypes.shape({
    key: PropTypes.string,
    enabled: PropTypes.bool,
    order: PropTypes.number,
    title: PropTypes.string,
    image: PropTypes.string,
    alt: PropTypes.string,
    button: PropTypes.shape({
      text: PropTypes.string,
      icon: PropTypes.string,
      url: PropTypes.string,
    }),
  }),
};

ContactHero.defaultProps = {
  data: null,
  overviewVideo: null,
};
